/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { MONITORING } from 'apps/console-core/src/Constants/DxpCapabilities/DxpCapabilityItems.constants';

/**
 * The paths for each screen.
 */
export const screenPaths = {
  experienceMonitoring: `${MONITORING.path}/experience-monitoring`,
  experienceMonitoringDomainPage: `${MONITORING.path}/experience-monitoring/:url`,
  logs: `${MONITORING.path}/logs`,
  monitoringDashboard: MONITORING.path,
};
